import { lazy, type ComponentType, type ReactNode } from "react";
import type { Capability } from "@hik/contracts";
import { useSession } from "../../lib/session";
import { LinkButton } from "../../ui/Button";
import { Empty } from "../../ui/States";
import { PageHeader } from "../../ui/Page";

/** Yetkisi olmayan kişi doğrudan adresle gelirse: açık mesaj + ana ekrana dönüş. Asıl denetim sunucuda. */
export function RequireCap({ any, title, children }: { any: Capability[]; title: string; children: ReactNode }) {
  const { can } = useSession();
  if (any.some((c) => can(c))) return <>{children}</>;
  return (
    <div className="page page--narrow hr-page">
      <PageHeader title={title} />
      <Empty title="Bu sayfa size açık değil." action={<LinkButton to="/" variant="secondary">Ana ekrana dön</LinkButton>}>
        Bu ekranı İK ekibi kullanır. Erişim gerekiyorsa şirketinizin İK yöneticisine başvurun.
      </Empty>
    </div>
  );
}

/**
 * Rota düzeyinde koruma: sayfa bileşenini tembel yükler ve yetki yoksa açık mesaj gösterir
 * (menüde görünmeyen İK sayfası adresle açıldığında boş iskelet + 403 kutusu yerine).
 */
export function guarded(any: Capability[], title: string, load: () => Promise<{ default: ComponentType }>) {
  return lazy(async () => {
    const { default: Page } = await load();
    return {
      default: function GuardedPage() {
        return (
          <RequireCap any={any} title={title}>
            <Page />
          </RequireCap>
        );
      },
    };
  });
}
